import api from './api'

export default class AuthService {
  static startSession(payload) {
    return api.post('/start_session', {
      bank: payload.bankId,
      brand: payload.brand,
      country: payload.country,
      psu_type: payload.psu_type,
      success_uri: payload.successUrl,
      failure_uri: payload.failureUrl
    })
  }

  static getSessionStatus() {
    return api.get('/get_session_status')
  }

  static closeSession() {
    return api.post('/close_session')
  }
}
